import { Icon } from '@design-system/index'
import { colors } from '@design-system/styles'
import { Observer } from 'mobx-react'
import { useEffect } from 'react'
import { ERROR_REPORT_ARITHMETIC, TOAST_STR } from 'src/constant'
import type { ErrorReport } from 'src/dto'

import { _OldButton } from '@/component/atoms/Button/_OldButton'
import { Radio } from '@/component/molecules/Radio'
import ModalTemplate from '@/component/templates/ModalTemplate/ModalTemplate'
import useSetRepository from '@/hooks/useSetRepository'
import ErrorReportService from '@/service/errorReport.service'
import modalService from '@/service/modal.service'
import { commonErrorMessage, toastError, toastSuccess } from '@/utils/toast'

import S from './ErrorReport.style'

type Props = {
  categoryId: number // 신고할 문제, 학습지, 개념 아이디
}

const ErrorReportArithmetic = ({ categoryId }: Props) => {
  const service = useSetRepository(ErrorReportService, 'ARITHMETIC', categoryId)

  const onSubmit = async () => {
    try {
      await service.postErrorReportArithmetic()
      modalService.closeModal()
      toastSuccess(TOAST_STR.createProblemErrorReport)
    } catch (e) {
      Number(e.status) === 400 ? toastError(e.message || TOAST_STR.err) : commonErrorMessage(e)
    }
  }

  useEffect(() => {
    return () => {
      service.clearErrorReport()
    }
  }, [])

  return (
    <Observer>
      {() => (
        <ModalTemplate
          css={S}
          header={
            <header className="error-report-header">
              <h2>
                문제 오류 신고
                <sub>빠른 시일 내로 수정하여 반영하겠습니다.</sub>
              </h2>
            </header>
          }
          body={
            <>
              <div className="error-report-description">
                <Icon name="info_fill" size={16} color={colors.gray.$700} />
                문제 수정 사항이 없을 경우 따로 연락드리지 않습니다.
              </div>
              <div className="error-report-body arithmetic">
                <div className="radio-wrap">
                  <Radio.Group
                    name="error"
                    value={service.errorOption.subtype}
                    onChange={(e) => service.changeOption(e.target.value as ErrorReport['subtype'])}
                  >
                    {ERROR_REPORT_ARITHMETIC.map((option) => (
                      <Radio value={option.id} key={option.id} data-mathflat-unique-id={option.id}>
                        {option.name}
                      </Radio>
                    ))}
                  </Radio.Group>
                </div>

                <textarea
                  onChange={(event) => service.errorOption.update({ content: event.target.value })}
                  placeholder="(선택사항) 수정 시 참고할 내용을 간단히 작성해주세요."
                  value={service.errorOption.content}
                ></textarea>
              </div>
            </>
          }
          footer={
            <div className="error-report-footer">
              <_OldButton width={120} height={40} theme="primary-caution" onClick={onSubmit}>
                신고하기
              </_OldButton>
            </div>
          }
        />
      )}
    </Observer>
  )
}

export default ErrorReportArithmetic
